import SHA256 from 'sha.js';
import dayjs from 'dayjs';
import { SubmitResponse } from '@betty/registration/state';

export const mapRegistrationCompletedEventData = ({
  formData,
  account,
}: SubmitResponse) => ({
  email: SHA256('sha256').update(formData.email).digest('hex'),
  phoneNumber: SHA256('sha256')
    .update(`${formData.phone.phoneCode}${formData.phone.phoneNumber}`)
    .digest('hex'),
  firstName: SHA256('sha256').update(formData.firstName).digest('hex'),
  lastName: SHA256('sha256').update(formData.lastName).digest('hex'),
  dateOfBirth: SHA256('sha256')
    .update(dayjs(formData.birthDate, 'MM/DD/YYYY').format('YYYYMMDD'))
    .digest('hex'),
  gender: SHA256('sha256').update(formData.gender.slice(0, 1)).digest('hex'),
  city: SHA256('sha256').update(formData.address.city).digest('hex'),
  state: SHA256('sha256').update(formData.address.province).digest('hex'),
  zipCode: SHA256('sha256').update(formData.address.postalCode).digest('hex'),
  country: SHA256('sha256').update(formData.address.country).digest('hex'),
  accountId: SHA256('sha256').update(`${account.accountId}`).digest('hex'),
  advertiserTrackingEnabled: 'True',
  applicationTrackingEnabled: 'True',
  extinfo: [
    'a2',
    '',
    '',
    '',
    '10.1.1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  installId: localStorage.getItem('ajs_anonymous_id'),
  fbc: formData.marketingMeta?.fbclid
    ? `fb.1.${Date.now()}.${formData.marketingMeta.fbclid}`
    : undefined,
});
